export type VersionChip = 'ACTIVE' | 'SUPERSEDED' | 'DRAFT';

export function versionChip(
  version: { id: string; status: string },
  activeVersionId: string | null,
): VersionChip {
  if (version.status === 'DRAFT') return 'DRAFT';
  return version.id === activeVersionId ? 'ACTIVE' : 'SUPERSEDED';
}
